<section class="hero-banner-container hero-slider">
  <div id="herocarouselControls" class="carousel slide carousel-fade">
    <div class="carousel-inner">
      <div *ngFor="let slide of slides; let i = index" class="carousel-item" [class.active]="i === activeSlide">
        <div class="container">
          <div class="row" [ngClass]="slide.rowClass">
            <div [ngClass]="slide.colClass">
              <h5 class="hero-slide-title animate__animated animate__fadeInUp" [innerHTML]="slide.title"></h5>
              <h6 class="hero-slide-subtitle animate__animated animate__fadeInUp" [innerHTML]="slide.subtitle"></h6>
            </div>
            <ng-container *ngIf="slide.img">
              <div [ngClass]="slide.imgColClass">
                <img [src]="slide.img" [alt]="slide.imgAlt" class="banner-img animate__animated animate__pulse" [style]="slide.imgStyle">
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" (click)="prevSlide()">
      <span class="crsl-icon">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      </span>
    </button>
    <button class="carousel-control-next" type="button" (click)="nextSlide()">
      <span class="crsl-icon">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
      </span>
    </button>
  </div>
</section>
<!--site-main start-->
<div class="site-main">
  <!-- fid-section -->
  <section class="ttm-row bottomzero-padding-section bg-img6 position-relative z-1 clearfix" id="about">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-lg-11">
          <div class="ttm-bgcolor-skincolor ttm-bg ttm-col-bgcolor-yes ttm-left-span mb_80 res-991-mb-0">
            <div class="ttm-col-wrapper-bg-layer ttm-bg-layer">
              <div class="ttm-bg-layer-inner"></div>
            </div>
            <div class="layer-content">
              <div class="row">
                <div class="col-lg-11">
                  <div class="spacing-5">
                    <div class="section-title with-desc mb-40 clearfix">
                      <div class="title-header">
                        <h5>About Qualibar</h5>
                        <h2 class="title">
                          Trusted by our <span>Happy Customers</span>
                        </h2>
                      </div>
                      <div class="title-desc">
                        <p>
                          We listen. We advise. We design and develop together. Happy
                          customers and lasting relationships are what we strive for.
                          Success is measured by results, the most important being how
                          our clients feel about their experience with us. Their reviews show we’re onto something.
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="featured-icon-box style4 left-icon">
                          <div class="featured-icon">
                            <div class="ttm-icon ttm-icon_element-color-white ttm-icon_element-size-md">
                              <i class="flaticon flaticon-24h"></i>
                            </div>
                          </div>
                          <div class="featured-content">
                            <div class="featured-title">
                              <h5 class="fw-500">100% Customer Satisfaction</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="featured-icon-box style4 left-icon">
                          <div class="featured-icon">
                            <div class="ttm-icon ttm-icon_element-color-white ttm-icon_element-size-md">
                              <i class="flaticon flaticon-data"></i>
                            </div>
                          </div>
                          <div class="featured-content">
                            <div class="featured-title">
                              <h5 class="fw-500">World Class Architecture</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="featured-icon-box style4 left-icon">
                          <div class="featured-icon">
                            <div class="ttm-icon ttm-icon_element-color-white ttm-icon_element-size-md">
                              <i class="flaticon flaticon-code"></i>
                            </div>
                          </div>
                          <div class="featured-content">
                            <div class="featured-title">
                              <h5 class="fw-500">World Class Design</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- services section  -->
  <div class="services-list " id="services" style="display: none !important;">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center mb-5">
          <h6 class="title-primary ">
            QA Services
          </h6>
          <h6 class="service-subtitle ">
            30% Increase in Speed-to-Market with our QA Testing
            Services
          </h6>
          <p class="service-description">
            Qualibar provides QA software testing services to validate different functions of your application, all
            managed in our top-notch testing labs. Our certified testing
            team can ensure faster time-to-market for your software products with the deployment of automated regression
            test suites.
          </p>
        </div>
        <div class="service-list-container mt-2 pb-3">
          <div class="service-list-card mobiel-testing-card" onclick="location.href='qaservice.html#mobiletesting'">
            <img src="./images/services/mobileapp-testing.svg" alt="" class="service-img">
            <h6 class="service-name">Mobile App Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card browser-testing-card" onclick="location.href='qaservice.html#browsertesting'">
            <img src="./images/services/crossbrowser-testing.svg" alt="" class="service-img">
            <h6 class="service-name">Browser Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card api-testing-card" onclick="location.href='qaservice.html#apitesting'">
            <img src="./images/services/api-testing.svg" alt="" class="service-img">
            <h6 class="service-name">API Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card ott-testing-card" onclick="location.href='qaservice.html#otttesting'">
            <img src="./images/services/otttesting.svg" alt="" class="service-img">
            <h6 class="service-name">OTT Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card iot-testing-card" onclick="location.href='qaservice.html#iottesting'">
            <img src="./images/services/iottesting.svg" alt="" class="service-img">
            <h6 class="service-name">IOT Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card ai-testing-card" onclick="location.href='qaservice.html#aitesting'">
            <img src="./images/services/AI-testing.svg" alt="" class="service-img">
            <h6 class="service-name">AI & ML Intelligent Test Automation</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card mobiel-testing-card"
            onclick="location.href='qaservice.html#performancetesting'">
            <img src="./images/services/performance-testing.svg" alt="" class="service-img">
            <h6 class="service-name">Performance Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card dataint-testing-card" onclick="location.href='qaservice.html#datatesting'">
            <img src="./images/services/dataintegrity-testing.svg" alt="" class="service-img">
            <h6 class="service-name">Data Integrity Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card box-testing-card" onclick="location.href='qaservice.html#boxtesting'">
            <img src="./images/services/boxtesting.svg" alt="" class="service-img">
            <h6 class="service-name">Black Box & White Box Testing</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
          <div class="service-list-card automation-testing-card"
            onclick="location.href='qaservice.html#automationtesting'">
            <img src="./images/services/testing-automation.svg" alt="" class="service-img">
            <h6 class="service-name" style="white-space: nowrap;">Testing Automation <br> (CI/CD
              Integration)</h6>
            <ul class="service-keylist">
              <li>User Experience Testing</li>
              <li>Usability Testing</li>
              <li>Security Testing</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- first-row-title-section -->
  <section class="ttm-row first-row-title-section mt_10 ttm-bgcolor-darkgrey ttm-bg ttm-bgimage-yes bg-img9 clearfix"
    id="weoffer">
    <div class="ttm-row-wrapper-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <!-- row -->
        <div class="col-md-12 ">
          <h2 class="title text-center mb-50 title-shop">One Stop Shop</h2>
        </div>
        <div class="col-lg-12 row onestop-shop-container">
          <!-- section-title -->
          <div class="col-md-4 text-center border-right-1">
            <div class="section-title row-title clearfix">
              <div class="title-header">
                <h3 class="title" style="color:white;">AI Consulting</h3>
              </div>
              <div class="title-desc">
                We have deep experience with AI-native projects, and the expertise to make these new technologies work
                for you.
              </div>
            </div>
          </div>
          <div class="col-md-4 text-center featured-icon-box border-right-1">
            <div class="section-title row-title clearfix">
              <div class="title-header">
                <h3 class="title" style="color:white;">Staff Augmentation</h3>
              </div>
              <div class="title-desc">
                We provide quality resources who will be an integral part of your team and work with your leadership to
                deliver results.
              </div>
            </div>
          </div>
          <div class="col-md-4 text-center ">
            <div class="section-title row-title clearfix">
              <div class="title-header">
                <h3 class="title" style="color:white;">Software Development</h3>
              </div>
              <div class="title-desc">We take absolute responsibility for all of your software development needs.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>